import classnames from 'classnames'
import { CurrentUserRoleType } from '~/graphqls/types'
import { getCurrentUserRole, UserRoleType } from '~/utils'

type VipType = {
  /** 用户角色 */
  userRole: UserRoleType | null | undefined
  /** 是否有描边 */
  border?: boolean
  style?: React.CSSProperties
  className?: string
}

/** tip:
 * 1. 兼容safari,样式需要都携带max-width,一般最大宽度时高度的1.5倍即可
 * 2. relative如果是a标签，需要变成blcok；
 *  */
export function VipIcon({
  userRole = {
    artist: false,
    aiArtist: false,
  },
  border = true,
  style,
  className,
}: VipType) {
  const role = getCurrentUserRole(userRole)
  return (
    <div
      className={classnames(
        className,
        border ? 'flex absolute bottom-0 right-0' : 'flex ml-1'
      )}
      style={style}
    >
      {role === CurrentUserRoleType.AI_ARTIST ? (
        border ? (
          <VipAiBorder />
        ) : (
          <VipAi />
        )
      ) : null}
      {role === CurrentUserRoleType.ARTIST ? (
        border ? (
          <VipNormalBorder />
        ) : (
          <VipNormal />
        )
      ) : null}
      {role === CurrentUserRoleType.ARTIST_AND_AIARTIST ? (
        border ? (
          <VipAiAndNoramlBorder />
        ) : (
          <VipAiAndNoraml />
        )
      ) : null}
    </div>
  )
}

/** 无边的普通创作者 */
export function VipNormal() {
  return (
    <svg
      className="w-full h-full"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.05029 2.05029L7 0L4.94971 2.05029H2.05078V4.94922L0 7L2.05078 9.05078V11.9498H4.94979L7 14L9.05021 11.9498H11.9503V9.04972L14 7L11.9503 4.95028V2.05029H9.05029Z"
        fill="#7851EC"
      />
      <path
        d="M6.21635 9.91666H7.79327L9.625 4.66666H8.14904L7.0625 8.61489H6.97596L5.87981 4.66666H4.375L6.21635 9.91666Z"
        fill="#FCFCFD"
      />
    </svg>
  )
}
/** 无边的AI创作者 */
export function VipAi() {
  return (
    <svg
      className="w-full h-full"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.05029 2.05029L7 0L4.94971 2.05029H2.05078V4.94922L0 7L2.05078 9.05078V11.9498H4.94979L7 14L9.05021 11.9498H11.9503V9.04972L14 7L11.9503 4.95028V2.05029H9.05029Z"
        fill="#23262F"
      />
      <path
        d="M4.85099 9.625H3.5L5.25476 4.375H6.92826L8.68302 9.625H7.33203L6.11056 5.69775H6.06993L4.85099 9.625ZM4.67069 7.55884H7.49456V8.52271H4.67069V7.55884Z"
        fill="#FFD166"
      />
      <path d="M10.5 4.375V9.625H9.24297V4.375H10.5Z" fill="#FFD166" />
    </svg>
  )
}

/** 无边的AI创作者及普通创作者 */
export function VipAiAndNoraml() {
  return (
    <svg
      className="w-full h-full"
      width="23"
      height="14"
      viewBox="0 0 23 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.05029 2.05029L7 0L4.94971 2.05029H2.05078V4.94922L0 7L2.05078 9.05078V11.9498H4.94979L7 14L9.05021 11.9498H11.9503V9.04972L14 7L11.9503 4.95028V2.05029H9.05029Z"
        fill="#23262F"
      />
      <path
        d="M4.85099 9.625H3.5L5.25476 4.375H6.92826L8.68302 9.625H7.33203L6.11056 5.69775H6.06993L4.85099 9.625ZM4.67069 7.55884H7.49456V8.52271H4.67069V7.55884Z"
        fill="#FFD166"
      />
      <path d="M10.5 4.375V9.625H9.24297V4.375H10.5Z" fill="#FFD166" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0503 2.05029L16 0L13.9497 2.05029H11.0508V4.94922L9 7L11.0508 9.05078V11.9498H13.9498L16 14L18.0502 11.9498H20.9503V9.04972L23 7L20.9503 4.95028V2.05029H18.0503Z"
        fill="#7851EC"
      />
      <path
        d="M15.2163 9.91669H16.7933L18.625 4.66669H17.149L16.0625 8.61492H15.976L14.8798 4.66669H13.375L15.2163 9.91669Z"
        fill="#FCFCFD"
      />
    </svg>
  )
}

/** 有边的普通创作者 */
export function VipNormalBorder() {
  return (
    <svg
      className="w-full h-full"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="path-1-outside-1_10950_104794"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
        fill="black"
      >
        <rect fill="white" width="30" height="30" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.5148 6.51479L15 3L11.4852 6.51479H6.51562V11.4844L3 15L6.51562 18.5156V23.4853H11.4853L15 27L18.5146 23.4853H23.4862V18.5138L27 15L23.4862 11.4862V6.51479H18.5148Z"
        />
      </mask>
      <path
        d="M15 3L16.4142 1.58579L15 0.171573L13.5858 1.58579L15 3ZM18.5148 6.51479L17.1006 7.929L17.6864 8.51479H18.5148V6.51479ZM11.4852 6.51479V8.51479H12.3136L12.8994 7.929L11.4852 6.51479ZM6.51562 6.51479V4.51479H4.51562V6.51479H6.51562ZM6.51562 11.4844L7.92984 12.8986L8.51562 12.3128V11.4844H6.51562ZM3 15L1.58579 13.5858L0.171573 15L1.58579 16.4142L3 15ZM6.51562 18.5156H8.51562V17.6872L7.92984 17.1014L6.51562 18.5156ZM6.51562 23.4853H4.51562V25.4853H6.51562V23.4853ZM11.4853 23.4853L12.8996 22.0711L12.3138 21.4853H11.4853V23.4853ZM15 27L13.5858 28.4142L15 29.8284L16.4142 28.4142L15 27ZM18.5146 23.4853V21.4853H17.6862L17.1004 22.0711L18.5146 23.4853ZM23.4862 23.4853V25.4853H25.4862V23.4853H23.4862ZM23.4862 18.5138L22.072 17.0996L21.4862 17.6854V18.5138H23.4862ZM27 15L28.4142 16.4142L29.8284 15L28.4142 13.5858L27 15ZM23.4862 11.4862H21.4862V12.3146L22.072 12.9004L23.4862 11.4862ZM23.4862 6.51479H25.4862V4.51479H23.4862V6.51479ZM13.5858 4.41421L17.1006 7.929L19.929 5.10057L16.4142 1.58579L13.5858 4.41421ZM12.8994 7.929L16.4142 4.41421L13.5858 1.58579L10.071 5.10057L12.8994 7.929ZM6.51562 8.51479H11.4852V4.51479H6.51562V8.51479ZM8.51562 11.4844V6.51479H4.51562V11.4844H8.51562ZM4.41421 16.4142L7.92984 12.8986L5.10141 10.0702L1.58579 13.5858L4.41421 16.4142ZM7.92984 17.1014L4.41421 13.5858L1.58579 16.4142L5.10141 19.9298L7.92984 17.1014ZM8.51562 23.4853V18.5156H4.51562V23.4853H8.51562ZM11.4853 21.4853H6.51562V25.4853H11.4853V21.4853ZM16.4142 25.5858L12.8996 22.0711L10.0711 24.8996L13.5858 28.4142L16.4142 25.5858ZM17.1004 22.0711L13.5858 25.5858L16.4142 28.4142L19.9289 24.8996L17.1004 22.0711ZM23.4862 21.4853H18.5146V25.4853H23.4862V21.4853ZM21.4862 18.5138V23.4853H25.4862V18.5138H21.4862ZM25.5858 13.5858L22.072 17.0996L24.9004 19.928L28.4142 16.4142L25.5858 13.5858ZM22.072 12.9004L25.5858 16.4142L28.4142 13.5858L24.9004 10.072L22.072 12.9004ZM21.4862 6.51479V11.4862H25.4862V6.51479H21.4862ZM18.5148 8.51479H23.4862V4.51479H18.5148V8.51479Z"
        fill="white"
        mask="url(#path-1-outside-1_10950_104794)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5148 6.51479L15 3L11.4852 6.51479H6.51562V11.4844L3 15L6.51562 18.5156V23.4853H11.4853L15 27L18.5146 23.4853H23.4862V18.5138L27 15L23.4862 11.4862V6.51479H18.5148Z"
        fill="#7851EC"
      />
      <path
        d="M13.6566 20H16.3599L19.5 11H16.9698L15.1071 17.7684H14.9588L13.0797 11H10.5L13.6566 20Z"
        fill="#FCFCFD"
      />
    </svg>
  )
}

/** 有边的AI创作者 */
export function VipAiBorder() {
  return (
    <svg
      className="w-full h-full "
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="path-1-outside-1_10950_104802"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
        fill="black"
      >
        <rect fill="white" width="30" height="30" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.5148 6.51479L15 3L11.4852 6.51479H6.51562V11.4844L3 15L6.51562 18.5156V23.4853H11.4853L15 27L18.5146 23.4853H23.4862V18.5138L27 15L23.4862 11.4862V6.51479H18.5148Z"
        />
      </mask>
      <path
        d="M15 3L16.4142 1.58579L15 0.171573L13.5858 1.58579L15 3ZM18.5148 6.51479L17.1006 7.929L17.6864 8.51479H18.5148V6.51479ZM11.4852 6.51479V8.51479H12.3136L12.8994 7.929L11.4852 6.51479ZM6.51562 6.51479V4.51479H4.51562V6.51479H6.51562ZM6.51562 11.4844L7.92984 12.8986L8.51562 12.3128V11.4844H6.51562ZM3 15L1.58579 13.5858L0.171573 15L1.58579 16.4142L3 15ZM6.51562 18.5156H8.51562V17.6872L7.92984 17.1014L6.51562 18.5156ZM6.51562 23.4853H4.51562V25.4853H6.51562V23.4853ZM11.4853 23.4853L12.8996 22.0711L12.3138 21.4853H11.4853V23.4853ZM15 27L13.5858 28.4142L15 29.8284L16.4142 28.4142L15 27ZM18.5146 23.4853V21.4853H17.6862L17.1004 22.0711L18.5146 23.4853ZM23.4862 23.4853V25.4853H25.4862V23.4853H23.4862ZM23.4862 18.5138L22.072 17.0996L21.4862 17.6854V18.5138H23.4862ZM27 15L28.4142 16.4142L29.8284 15L28.4142 13.5858L27 15ZM23.4862 11.4862H21.4862V12.3146L22.072 12.9004L23.4862 11.4862ZM23.4862 6.51479H25.4862V4.51479H23.4862V6.51479ZM13.5858 4.41421L17.1006 7.929L19.929 5.10057L16.4142 1.58579L13.5858 4.41421ZM12.8994 7.929L16.4142 4.41421L13.5858 1.58579L10.071 5.10057L12.8994 7.929ZM6.51562 8.51479H11.4852V4.51479H6.51562V8.51479ZM8.51562 11.4844V6.51479H4.51562V11.4844H8.51562ZM4.41421 16.4142L7.92984 12.8986L5.10141 10.0702L1.58579 13.5858L4.41421 16.4142ZM7.92984 17.1014L4.41421 13.5858L1.58579 16.4142L5.10141 19.9298L7.92984 17.1014ZM8.51562 23.4853V18.5156H4.51562V23.4853H8.51562ZM11.4853 21.4853H6.51562V25.4853H11.4853V21.4853ZM16.4142 25.5858L12.8996 22.0711L10.0711 24.8996L13.5858 28.4142L16.4142 25.5858ZM17.1004 22.0711L13.5858 25.5858L16.4142 28.4142L19.9289 24.8996L17.1004 22.0711ZM23.4862 21.4853H18.5146V25.4853H23.4862V21.4853ZM21.4862 18.5138V23.4853H25.4862V18.5138H21.4862ZM25.5858 13.5858L22.072 17.0996L24.9004 19.928L28.4142 16.4142L25.5858 13.5858ZM22.072 12.9004L25.5858 16.4142L28.4142 13.5858L24.9004 10.072L22.072 12.9004ZM21.4862 6.51479V11.4862H25.4862V6.51479H21.4862ZM18.5148 8.51479H23.4862V4.51479H18.5148V8.51479Z"
        fill="white"
        mask="url(#path-1-outside-1_10950_104802)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5148 6.51479L15 3L11.4852 6.51479H6.51562V11.4844L3 15L6.51562 18.5156V23.4853H11.4853L15 27L18.5146 23.4853H23.4862V18.5138L27 15L23.4862 11.4862V6.51479H18.5148Z"
        fill="#23262F"
      />
      <path
        d="M11.316 19.5H9L12.0082 10.5H14.877L17.8852 19.5H15.5692L13.4752 12.7676H13.4056L11.316 19.5ZM11.0069 15.958H15.8478V17.6104H11.0069V15.958Z"
        fill="#FFD166"
      />
      <path d="M21 10.5V19.5H18.8451V10.5H21Z" fill="#FFD166" />
    </svg>
  )
}

/** 有边的AI创作者及普通创作者 */
export function VipAiAndNoramlBorder() {
  return (
    <svg
      className="w-full h-full"
      width="44"
      height="30"
      viewBox="0 0 44 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="path-1-outside-1_10950_104793"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
        fill="black"
      >
        <rect fill="white" width="30" height="30" />
        <path d="M18.5148 6.51479L15 3L11.4852 6.51479H6.51563V11.4844L3 15L6.51563 18.5156V23.4854H11.4854L15 27L18.5146 23.4854H23.4862V18.5138L27 15L23.4862 11.4862V6.51479H18.5148Z" />
      </mask>
      <path
        d="M15 3L16.4142 1.58579L15 0.171573L13.5858 1.58579L15 3ZM18.5148 6.51479L17.1006 7.929L17.6864 8.51479H18.5148V6.51479ZM11.4852 6.51479V8.51479H12.3136L12.8994 7.929L11.4852 6.51479ZM6.51563 6.51479V4.51479H4.51563V6.51479H6.51563ZM6.51563 11.4844L7.92984 12.8986L8.51562 12.3128V11.4844H6.51563ZM3 15L1.58579 13.5858L0.171573 15L1.58579 16.4142L3 15ZM6.51563 18.5156H8.51562V17.6872L7.92984 17.1014L6.51563 18.5156ZM6.51563 23.4854H4.51563V25.4854H6.51563V23.4854ZM11.4854 23.4854L12.8996 22.0711L12.3138 21.4854H11.4854V23.4854ZM15 27L13.5858 28.4142L15 29.8284L16.4142 28.4142L15 27ZM18.5146 23.4854V21.4854H17.6862L17.1004 22.0711L18.5146 23.4854ZM23.4862 23.4854V25.4854H25.4862V23.4854H23.4862ZM23.4862 18.5138L22.072 17.0996L21.4862 17.6854V18.5138H23.4862ZM27 15L28.4142 16.4142L29.8284 15L28.4142 13.5858L27 15ZM23.4862 11.4862H21.4862V12.3146L22.072 12.9004L23.4862 11.4862ZM23.4862 6.51479H25.4862V4.51479H23.4862V6.51479ZM13.5858 4.41421L17.1006 7.929L19.929 5.10057L16.4142 1.58579L13.5858 4.41421ZM12.8994 7.929L16.4142 4.41421L13.5858 1.58579L10.071 5.10057L12.8994 7.929ZM6.51563 8.51479H11.4852V4.51479H6.51563V8.51479ZM8.51562 11.4844V6.51479H4.51563V11.4844H8.51562ZM4.41421 16.4142L7.92984 12.8986L5.10141 10.0702L1.58579 13.5858L4.41421 16.4142ZM7.92984 17.1014L4.41421 13.5858L1.58579 16.4142L5.10141 19.9298L7.92984 17.1014ZM8.51562 23.4854V18.5156H4.51563V23.4854H8.51562ZM11.4854 21.4854H6.51563V25.4854H11.4854V21.4854ZM16.4142 25.5858L12.8996 22.0711L10.0711 24.8996L13.5858 28.4142L16.4142 25.5858ZM17.1004 22.0711L13.5858 25.5858L16.4142 28.4142L19.9289 24.8996L17.1004 22.0711ZM23.4862 21.4854H18.5146V25.4854H23.4862V21.4854ZM21.4862 18.5138V23.4854H25.4862V18.5138H21.4862ZM25.5858 13.5858L22.072 17.0996L24.9004 19.928L28.4142 16.4142L25.5858 13.5858ZM22.072 12.9004L25.5858 16.4142L28.4142 13.5858L24.9004 10.072L22.072 12.9004ZM21.4862 6.51479V11.4862H25.4862V6.51479H21.4862ZM18.5148 8.51479H23.4862V4.51479H18.5148V8.51479Z"
        fill="white"
        mask="url(#path-1-outside-1_10950_104793)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5148 6.51479L15 3L11.4852 6.51479H6.51563V11.4844L3 15L6.51563 18.5156V23.4854H11.4854L15 27L18.5146 23.4854H23.4862V18.5138L27 15L23.4862 11.4862V6.51479H18.5148Z"
        fill="#23262F"
      />
      <path
        d="M11.316 19.5H9L12.0082 10.5H14.877L17.8852 19.5H15.5692L13.4752 12.7676H13.4056L11.316 19.5ZM11.0069 15.958H15.8478V17.6104H11.0069V15.958Z"
        fill="#FFD166"
      />
      <path d="M21 10.5V19.5H18.8451V10.5H21Z" fill="#FFD166" />
      <mask
        id="path-5-outside-2_10950_104793"
        maskUnits="userSpaceOnUse"
        x="13.5"
        y="0"
        width="30"
        height="30"
        fill="black"
      >
        <rect fill="white" x="13.5" width="30" height="30" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.0148 6.51479L28.5 3L24.9852 6.51479H20.0156V11.4844L16.5 15L20.0156 18.5156V23.4853H24.9853L28.5 27L32.0146 23.4853H36.9862V18.5138L40.5 15L36.9862 11.4862V6.51479H32.0148Z"
        />
      </mask>
      <path
        d="M28.5 3L29.9142 1.58579L28.5 0.171573L27.0858 1.58579L28.5 3ZM32.0148 6.51479L30.6006 7.929L31.1864 8.51479H32.0148V6.51479ZM24.9852 6.51479V8.51479H25.8136L26.3994 7.929L24.9852 6.51479ZM20.0156 6.51479V4.51479H18.0156V6.51479H20.0156ZM20.0156 11.4844L21.4298 12.8986L22.0156 12.3128V11.4844H20.0156ZM16.5 15L15.0858 13.5858L13.6716 15L15.0858 16.4142L16.5 15ZM20.0156 18.5156H22.0156V17.6872L21.4298 17.1014L20.0156 18.5156ZM20.0156 23.4853H18.0156V25.4853H20.0156V23.4853ZM24.9853 23.4853L26.3996 22.0711L25.8138 21.4853H24.9853V23.4853ZM28.5 27L27.0858 28.4142L28.5 29.8284L29.9142 28.4142L28.5 27ZM32.0146 23.4853V21.4853H31.1862L30.6004 22.0711L32.0146 23.4853ZM36.9862 23.4853V25.4853H38.9862V23.4853H36.9862ZM36.9862 18.5138L35.572 17.0996L34.9862 17.6854V18.5138H36.9862ZM40.5 15L41.9142 16.4142L43.3284 15L41.9142 13.5858L40.5 15ZM36.9862 11.4862H34.9862V12.3146L35.572 12.9004L36.9862 11.4862ZM36.9862 6.51479H38.9862V4.51479H36.9862V6.51479ZM27.0858 4.41421L30.6006 7.929L33.429 5.10057L29.9142 1.58579L27.0858 4.41421ZM26.3994 7.929L29.9142 4.41421L27.0858 1.58579L23.571 5.10057L26.3994 7.929ZM20.0156 8.51479H24.9852V4.51479H20.0156V8.51479ZM22.0156 11.4844V6.51479H18.0156V11.4844H22.0156ZM17.9142 16.4142L21.4298 12.8986L18.6014 10.0702L15.0858 13.5858L17.9142 16.4142ZM21.4298 17.1014L17.9142 13.5858L15.0858 16.4142L18.6014 19.9298L21.4298 17.1014ZM22.0156 23.4853V18.5156H18.0156V23.4853H22.0156ZM24.9853 21.4853H20.0156V25.4853H24.9853V21.4853ZM29.9142 25.5858L26.3996 22.0711L23.5711 24.8996L27.0858 28.4142L29.9142 25.5858ZM30.6004 22.0711L27.0858 25.5858L29.9142 28.4142L33.4289 24.8996L30.6004 22.0711ZM36.9862 21.4853H32.0146V25.4853H36.9862V21.4853ZM34.9862 18.5138V23.4853H38.9862V18.5138H34.9862ZM39.0858 13.5858L35.572 17.0996L38.4004 19.928L41.9142 16.4142L39.0858 13.5858ZM35.572 12.9004L39.0858 16.4142L41.9142 13.5858L38.4004 10.072L35.572 12.9004ZM34.9862 6.51479V11.4862H38.9862V6.51479H34.9862ZM32.0148 8.51479H36.9862V4.51479H32.0148V8.51479Z"
        fill="white"
        mask="url(#path-5-outside-2_10950_104793)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.0148 6.51479L28.5 3L24.9852 6.51479H20.0156V11.4844L16.5 15L20.0156 18.5156V23.4853H24.9853L28.5 27L32.0146 23.4853H36.9862V18.5138L40.5 15L36.9862 11.4862V6.51479H32.0148Z"
        fill="#7851EC"
      />
      <path
        d="M27.1566 20H29.8599L33 11H30.4698L28.6071 17.7684H28.4588L26.5797 11H24L27.1566 20Z"
        fill="#FCFCFD"
      />
    </svg>
  )
}
